import { observable } from 'mobx'

export class UIStore {
	@observable
	accessor selectedDay: Date = new Date();

	@observable
	accessor isMenuOpen: boolean = false;
}